import { render } from "./PasswordRestore.vue?vue&type=template&id=3ac8766a&scoped=true"
import script from "./PasswordRestore.vue?vue&type=script&lang=js"
export * from "./PasswordRestore.vue?vue&type=script&lang=js"

import "./PasswordRestore.vue?vue&type=style&index=0&id=3ac8766a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac8766a"]])

export default __exports__